import React, { useEffect, useState } from "react";
import styles from "./ApplicantsListModal.module.scss";
import { API } from "service/Interceptor";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import { formatDateToReadable } from "utils/constants";
import { applicantDisplayName } from "utils/utils";
import Pagination from "components/common/Table/Pagination";

const ApplicantsListModal = ({ jobId, onClose }) => {
    const [applicants, setApplicants] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pageSelected, setPageSelected] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const rowsPerPageValue = 10;

    useEffect(() => {
        const fetchApplicants = async () => {
            try {
                setIsLoading(true);
                const res = await API.get(`api/jobs/${jobId}/applicants`, {
                    params: {
                        page: Math.max(0, pageSelected - 1),
                        size: rowsPerPageValue,
                    },
                    skipErrorToast: true,
                });
                setApplicants(res?.data?.data?.results || []);
                setTotalCount(res?.data?.data?.totalRecord || 0);
            } catch (error) {
                console.error("Error fetching applicants:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (jobId) {
            fetchApplicants();
        }
    }, [jobId, pageSelected]);

    return (
        <section className={styles.overlay} onClick={onClose}>
            <div
                className={styles.modalContainer}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <h2>Applicants List</h2>
                    <span className={styles.closeBtn} onClick={onClose}>
                        <CrossIconSVG color="#6570fc" />
                    </span>
                </div>
                <div className={styles.modalBody}>
                    {isLoading ? (
                        <div className={styles.loaderContainer}>
                            <SpinnerLoader />
                        </div>
                    ) : applicants?.length > 0 ? (
                        <div className={styles.tableWrapper}>
                            <table className={styles.applicantsTable}>
                                <thead>
                                    <tr>
                                        <th>Applied Date</th>
                                        <th>Applicant Name</th>
                                        <th>Email Id</th>
                                        <th>Mobile Number</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {applicants.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                              {item?.appliedAt
                                                ? Array.isArray(formatDateToReadable(item.appliedAt))
                                                  ? formatDateToReadable(item.appliedAt).join(" ")
                                                  : String(formatDateToReadable(item.appliedAt))
                                                : "-"}
                                            </td>
                                            <td>{applicantDisplayName(item)}</td>
                                            <td>{item?.email}</td>
                                            <td>{item?.mobileNo || "N/A"}</td>
                                            <td>
                                                <span className={`${styles.statusBadge} ${styles[item?.applicationStatus?.toLowerCase() || 'pending']}`}>
                                                    {item?.applicationStatus || "Pending"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className={styles.noData}>No applicants found for this project.</p>
                    )}
                </div>
                {applicants?.length > 0 && totalCount > rowsPerPageValue && (
                    <div className={styles.modalFooter}>
                        <Pagination
                            pageSelected={pageSelected}
                            setPageSelected={setPageSelected}
                            rowsPerPageValue={rowsPerPageValue}
                            totalCount={totalCount}
                            className={styles.paginationOverride}
                        />
                    </div>
                )}
            </div>
        </section>
    );
};

export default ApplicantsListModal;
